// src/components/Filters/JobTitlesFilter.js
import { Field, useFormikContext } from 'formik';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { InputSelect } from '../Select';
import { debounceIndexJobTitleRequest } from '../../../requests/jobTitles'; // nombre corregido
import { pairValue, resultFetchData } from './utils';

const JobTitlesFilter = ({ formikValue, params }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const [jobTitles, setJobTitles] = useState([]);

  const fetchJobTitles = (inputValue, callback) => {
    debounceIndexJobTitleRequest({
      dispatch,
      params: {
        actives: true,
        name: inputValue,
        sort_column: 'name',
        paginate: false,
        ...params
      },
      successCallback: data => {
        const list = resultFetchData(data);
        setJobTitles(list);
        callback(list);
      }
    });
  };

  return (
    <Field name={formikValue}>
      {({ field }) => (
        <InputSelect
          {...field}
          label="Cargo"
          placeholder="Seleccionar Cargo"
          request={fetchJobTitles}
          defaultValue={pairValue(jobTitles, values[formikValue])}
          onChange={data => setFieldValue(field.name, data ? data.value : '')}
          isClearable
        />
      )}
    </Field>
  );
};

export default JobTitlesFilter;
